module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_18.01c49a15.jpg";